import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async toggle() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/html"
      }
    })

    if (response.ok) {
      const html = await response.text()
      this.element.outerHTML = html
    }
  }
}
